var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReminderHistory = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reminder_history",
    "data-name": "reminder history",
    transform: "translate(10552 -15154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "history_1_",
    "data-name": "history (1)",
    transform: "translate(-10550 15157)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4974",
    "data-name": "Path 4974",
    d: "M275.483,172.228l0,4.4a.628.628,0,0,0,.184.445l3.147,3.146.889-.889-2.963-2.962,0-4.138Z",
    transform: "translate(-265.5 -167.253)",
    fill: "#151e24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4975",
    "data-name": "Path 4975",
    d: "M11.25,34.445a8.756,8.756,0,0,0-8.65,7.5H0L3.125,45.07,6.25,41.945H3.863a7.487,7.487,0,1,1,1.473,5.863l-.985.769a8.75,8.75,0,1,0,6.9-14.132Z",
    transform: "translate(0 -34.445)",
    fill: "#151e24"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_674",
    "data-name": "Rectangle 674",
    width: 24,
    height: 24,
    transform: "translate(-10552 15154)",
    fill: "none"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReminderHistory);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/reminder_history.bf0c7622bb286b87144e31b3dbc2b4ad.svg";